import React from 'react';

import { useTranslation } from 'react-i18next';

import { ROUTES } from '@utils/routes.ts';

import cardImg1 from '@assets/images/nomad/nomad_bonus_card_1.webp';
import cardImg2 from '@assets/images/nomad/nomad_bonus_card_2.webp';
import cardImg3 from '@assets/images/nomad/nomad_bonus_card_3.webp';
import cardImg4 from '@assets/images/nomad/nomad_bonus_card_4.webp';
import cardImg5 from '@assets/images/nomad/nomad_bonus_card_5.webp';
import cardImg6 from '@assets/images/nomad/nomad_bonus_card_6.webp';

import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';

import { Banner } from './components/banner';
import { Bonuses } from './components/bonuses';
import { Card } from './components/card';
import { NCoins } from './components/n-coins';
import { Quests } from './components/quests';
import { Shop } from './components/shop';
import * as Styled from './home-nomad.styles';

const HomeNomad = () => {
	const { data: userData } = useQueryGetMe();
	const { t } = useTranslation('main');

	if (!userData) {
		return null;
	}

	return (
		<Styled.Wrapper>
			{userData?.pm_id ? (
				<>
					<Banner />
					<Styled.CardWrapper>
						<Card title={t('quests')} link={ROUTES.QUESTS} image={cardImg1} />
						<Card title={t('shop')} link={ROUTES.SHOP} image={cardImg2} />
						<Card title={t('tournaments')} link={ROUTES.TOURNAMENTS} image={cardImg3} />
						{/* Need to add later */}
						<Card title={t('promotions')} link={'/'} image={cardImg4} />
						<Card title={t('profile')} link={ROUTES.PROFILE} image={cardImg5} />
						<Card title={t('doBetsNomad')} link={'https://nomad-casino-12.com/'} image={cardImg6} />
					</Styled.CardWrapper>
				</>
			) : (
				<>
					<Bonuses />
					<Styled.Separator />
					<NCoins />
					<Styled.Separator />
					<Quests />
					<Styled.Separator />
					<Shop />
				</>
			)}
		</Styled.Wrapper>
	);
};

export default HomeNomad;
